if (!customElements.get('tab-mega-menu')) {
  class MegaMenuTab extends HTMLElement {
    constructor() {
      super();
      this.tabMenu = Array.from(this.querySelectorAll('[tab-menu]'));
      this.tabContent = Array.from(this.querySelectorAll('[tab-content]'));
      this._onTabActivate = this._onTabActivate.bind(this);

      // ✅ Rotácia len tam, kde chceš (a kde existujú varianty)
      this.ROTATE = {
        "ovocne-stromy": 3 // base + --2 + --3 (ak máš len --2, daj 2)
      };

      this._cycleIndex = Object.create(null);

      // AUTO-ROTATE (len desktop)
      this._autoTimer = null;
      this.AUTO_MS = 5000;

      // cache pre načítané URL (aby sme nerobili Image load stále dokola)
      this._loaded = new Set();
    }

    connectedCallback() {
      if (!this.tabMenu.length) return;

      this.tabMenu.forEach((tab, index) => {
        tab.addEventListener('mouseenter', () => {
          this._onTabActivate(index);
        });

        tab.addEventListener('click', (e) => {
          if (e.isTrusted === false) {
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
            this._onTabActivate(index);
          }
        });
      });

      this.addEventListener('mouseleave', () => {
        this._stopAuto();
      });
    }

    _isDesktop() {
      return window.matchMedia && window.matchMedia('(min-width: 1025px)').matches;
    }

    _stopAuto() {
      if (this._autoTimer) {
        clearInterval(this._autoTimer);
        this._autoTimer = null;
      }
    }

    _startAutoIfEligible() {
      if (!this._isDesktop()) return;

      const active = this.querySelector('.mega-menu-tab-block.active');
      if (!active) return;

      const img = active.querySelector('.talia-drab-mm__promoimg[data-variants][data-handle]');
      if (!img) return;

      const handle = (img.getAttribute('data-handle') || '').trim();
      const maxN = this.ROTATE[handle];
      if (!maxN || maxN < 2) return;

      this._stopAuto();

      this._autoTimer = setInterval(() => {
        const a = this.querySelector('.mega-menu-tab-block.active');
        if (!a) return this._stopAuto();

        const i = a.querySelector('.talia-drab-mm__promoimg[data-handle]');
        if (!i) return this._stopAuto();

        const h = (i.getAttribute('data-handle') || '').trim();
        if (h !== handle) return this._stopAuto();

        this._cyclePromoInActiveTab();
      }, this.AUTO_MS);
    }

    _getPoolForActive(img, handle, maxN) {
      const base = img.getAttribute('data-base') || img.src;

      const raw = (img.getAttribute('data-variants') || '')
        .split('|')
        .map(s => (s || '').trim())
        .filter(Boolean);

      const wantedCount = Math.min(raw.length, Math.max(0, maxN - 1));
      const variants = raw.slice(0, wantedCount);

      const pool = [base, ...variants].filter(Boolean);
      return pool;
    }

    _preload(url) {
      if (!url) return Promise.resolve(false);
      if (this._loaded.has(url)) return Promise.resolve(true);

      return new Promise((resolve) => {
        const im = new Image();
        im.onload = () => {
          this._loaded.add(url);
          resolve(true);
        };
        im.onerror = () => resolve(false);
        im.decoding = 'async';
        im.src = url;
      });
    }

    async _swapWhenReady(img, url) {
      if (!url) return;

      // už je to zobrazené
      const current = img.currentSrc || img.src;
      if (current === url) return;

      // načítaj do cache; až potom prehoď src (žiadny “blank” flash)
      const ok = await this._preload(url);
      if (ok) img.src = url;
      // ak by zlyhalo, necháme starý src (žiadny fallback flash)
    }

    async _cyclePromoInActiveTab() {
      const active = this.querySelector('.mega-menu-tab-block.active');
      if (!active) return;

      const img = active.querySelector('.talia-drab-mm__promoimg[data-variants][data-handle]');
      if (!img) return;

      const handle = (img.getAttribute('data-handle') || '').trim();
      const maxN = this.ROTATE[handle];
      if (!maxN || maxN < 2) return;

      // aby sme nespúšťali paralelné swapy
      if (img.dataset.swapping === '1') return;
      img.dataset.swapping = '1';

      try {
        const pool = this._getPoolForActive(img, handle, maxN);
        if (pool.length <= 1) return;

        const prev = this._cycleIndex[handle] ?? -1;
        const next = (prev + 1) % pool.length;
        this._cycleIndex[handle] = next;

        await this._swapWhenReady(img, pool[next]);
      } finally {
        img.dataset.swapping = '0';
      }
    }

    _onTabActivate(activeIndex) {
      this.tabMenu.forEach((tab, idx) => {
        tab.classList.toggle('active', idx === activeIndex);
      });
      this.tabContent.forEach((content, idx) => {
        content.classList.toggle('active', idx === activeIndex);
      });

      // okamžitý switch pri vstupe do tabu (ale bezpečne – až po načítaní)
      this._cyclePromoInActiveTab();

      // auto-cycle, ak je to povolené pre tento handle
      this._startAutoIfEligible();
    }
  }

  customElements.define('tab-mega-menu', MegaMenuTab);
}
